/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {MomentModule} from 'ngx-moment';

import {PayEventsService} from '../+payrolls/events/payroll-events.service';
import {OngoingPayrollsService} from '../+payrolls/ongoing/ongoing-payrolls.service';
import {InboxModule} from '../inbox/inbox.module';
import {ChartsModule} from '../shared/charts/charts.module';
import {PipesModule} from '../shared/pipes/pipes.module';
import {UiModule} from '../shared/ui/ui.module';

import {DashboardComponent} from './dashboard.component';
import {DashboardService} from './dashboard.service';
import {PositionsCardComponent} from './positions-card/positions-card.component';
import {ProgressCardComponent} from './progress-card/progress-card.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MomentModule,
    ChartsModule,
    TranslateModule,
    InboxModule,
    PipesModule,
    UiModule
  ],
  declarations: [
    DashboardComponent,
    PositionsCardComponent,
    ProgressCardComponent
  ],
  exports: [
    DashboardComponent
  ],
  providers: [
    OngoingPayrollsService,
    PayEventsService,
    DashboardService
  ]
})
export class DashboardModule {
}
